module.exports = __webpack_public_path__ + "img/check_circle_24px.5b73149e.svg";